<template>
    <div>
        <el-checkbox v-model="check" @change="updateStore">{{
            $l10n.__('Rapprocher')
        }}</el-checkbox>
    </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
const { mapGetters: reconciliationGetters, mapMutations: reconciliationMutations } =
    createNamespacedHelpers('reconciliationStore');

export default {
    props: ['default', 'document', 'reference', 'amount', 'deadlines'],
    data() {
        return {
            check: this.default,
            uniqueId: '',
        };
    },
    computed: {
        ...reconciliationGetters(['transactionDate']),
    },
    methods: {
        ...reconciliationMutations(['addReconciled', 'delReconciled']),
        updateStore: function (check) {
            if (this.deadlines.length == 0) {
                Push.error(this.$l10n.__("Aucune échéance n'est sélectionnée"));
                this.check = false;
                return;
            }

            if (check) {
                const reconciliation = {
                    id: '_' + Math.random().toString(36).substr(2, 9),
                    ref: this.reference,
                    date: this.transactionDate,
                    amount: this.amount,
                    document: this.document,
                    deadlines: this.deadlines,
                };

                this.addReconciled(reconciliation);
                this.uniqueId = reconciliation.id;
                this.$emit('new-payment-confirmed');
            } else {
                this.delReconciled(this.uniqueId);
                this.uniqueId = '';
            }
        },
    },
};
</script>
